import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CampaignCalendarFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    public Get(type: Number): Observable<any> {
        return  this._httpClient.get<any>(this._urlBase + 'api/CampaignCalendar/' + type);
    }

    public GetByTaskOrganization(taskTypeId: Number, organizationId: String = ''): Observable<any> {
        return  this._httpClient.get<any>(this._urlBase + 'api/CampaignCalendar/ByTaskAndOrganizationId?taskTypeId='
        + taskTypeId + '&organizationId=' + organizationId);
    }

    public GetByOrganizations(type: Number, organizations: String = ''): Observable<any> {
        return  this._httpClient.get<any>(this._urlBase + 'api/CampaignCalendar/GetCampaignCalendar/ByTaskAndOrganizationId?taskTypeId='
        + type + '&organizations=' + organizations);
    }

    public GetCampaignCalendarByOrganizations(type: Number, organizations: String = ''): Observable<any> {
        return  this._httpClient.get<any>(this._urlBase + 'api/CampaignCalendar/GetByOrganizationList?typeTaskId='
        + type + '&organizations=' + organizations);
    }

    public saveCampaign(parameters: any): Observable<any> {
        const body = JSON.stringify(parameters);
        return this._httpClient.post(this._urlBase + 'api/CampaignCalendar/', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        });
    }

    public editCampaign(parameters: any): Observable<any> {
        const body = JSON.stringify(parameters);
        return this._httpClient.put(this._urlBase + 'api/CampaignCalendar/', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        });
    }
}
